import { FEATURE_TOGGLE_CONFIG } from '@wdpr/ra-angular-feature-toggle';
const ɵ0 = {
    wdprConversationCookieName: 'Conversation_UUID',
    wdprConversationHeader: 'X-Conversation-Id',
    wdprCorrelationHeader: 'X-Correlation-Id',
    wdprEndpointFilter: '(/error/?|homepage-banner-toggles\.json)'
}, ɵ1 = FEATURE_TOGGLE_CONFIG;
export class CoreModule {
}
export { ɵ0, ɵ1 };
